import { render, staticRenderFns } from "./SectionCard.vue?vue&type=template&id=00df2d3a&"
import script from "./SectionCard.vue?vue&type=script&lang=ts&"
export * from "./SectionCard.vue?vue&type=script&lang=ts&"
import style0 from "./SectionCard.vue?vue&type=style&index=0&id=00df2d3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports